import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as marked from 'marked';

@Pipe({
  name: 'chatbotMarkdown',
})
export class ChatbotMarkdownPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml | null {
    if (!value) {
      return null;
    }

    // Raw HTML from the model is dropped by marked and the result is sanitized by Angular.
    const html = marked.parse(value, { headerIds: false, mangle: false, sanitize: false } as marked.MarkedOptions);

    return this.sanitizer.sanitize(SecurityContext.HTML, html);
  }
}
